import React from 'react';
import clsx from 'classnames';

export interface SectionTitleProps
  extends React.ComponentPropsWithoutRef<'h3'> {
  children: React.ReactNode;
  className?: string;
}

export function SectionTitle({
  children,
  className,
  ...props
}: SectionTitleProps) {
  return (
    <h3 className={clsx('section-title', className)} {...props}>
      {children}
    </h3>
  );
}
